const DEFAULT_MAX_RETRIES = 2;
const DEFAULT_BASE_DELAY_MS = 1000;

function isRetryableGetError(error) {
  if (!error?.config) return false;
  const method = (error.config.method || "get").toLowerCase();
  if (method !== "get") return false;
  if (error.code === "ECONNABORTED" || error.message === "Network Error") {
    return true;
  }
  const status = error.response?.status;
  return !status || status >= 500;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function attachGetRetryInterceptor(
  client,
  { maxRetries = DEFAULT_MAX_RETRIES, baseDelayMs = DEFAULT_BASE_DELAY_MS } = {}
) {
  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const config = error.config;
      if (!config || !isRetryableGetError(error)) {
        return Promise.reject(error);
      }

      config.__retryCount = config.__retryCount || 0;
      if (config.__retryCount >= maxRetries) {
        return Promise.reject(error);
      }

      config.__retryCount += 1;
      await sleep(baseDelayMs * config.__retryCount);
      return client(config);
    }
  );
}
